import * as React from "react";
import { SFC } from "react";
import { Message as Error } from "semantic-ui-react";
import Message from "../../../domain/fundamentals/message/Message";

interface Props {
  message: Message;
}

const LoginErrorMessage: SFC<Props> = ({message}) => (
  <>
    {
      message.isEmpty() ? null : (
        <Error error={ true }>
          <Error.Header>エラー</Error.Header>
          <p>{ message.value }</p>
        </Error>
      )
    }
  </>
);

export default LoginErrorMessage;